/**
 * Copyright (C) 2018–2020 HERE Global B.V. and its affiliate(s).
 * All rights reserved.
 *
 * This software and other materials contain proprietary information
 * controlled by HERE and are protected by applicable copyright legislation.
 * Any use and utilization of this software and other materials and
 * disclosure to any third parties is conditional upon having a separate
 * agreement with HERE for the access, use, utilization or disclosure of this
 * software. In the absence of such agreement, the use of the software is not
 * allowed.
 */

import Component from './lui-notification'
import globalCss from 'lui-notification.global.scss'
import Group from './lui-notification-group'
import groupCss from 'lui-notification-group.global.scss'
import LuiNotificationTheme from './lui-notification-theme'
import LuiNotificationCss from 'lui-notification-theme.global.scss'

window.lui.registerComponent(Component, globalCss)
window.lui.registerComponent(Group, groupCss)
window.lui.registerComponent(LuiNotificationTheme, LuiNotificationCss)



//////////////////
// WEBPACK FOOTER
// ./packages/lui-notification/index.js
// module id = 261
// module chunks = 0 1 5